module.exports = __webpack_public_path__ + "img/10-info.7f2ce26d.svg";